const ReportFooter = () => {
  return (
    <div className="hidden" data-report-footer>
      <div className="flex flex-col items-center justify-center gap-3 rounded-xl border border-gray-200 bg-gray-50 px-6 py-8">
        <span className="text-sm font-medium text-gray-400">Powered by</span>
        <img src="/logo.svg" alt="TMA" className="h-10" />
      </div>
    </div>
  );
};

export default ReportFooter;
